import { CheckCircle } from "lucide-react";

interface VerificationSuccessProps {
  title?: string;
  message?: string;
  submessage?: string;
}

export const VerificationSuccess = ({ 
  title = "Success!",
  message = "Please check your email",
  submessage = "We've sent you an email with further instructions. It should arrive in a few minutes."
}: VerificationSuccessProps) => {
  return (
    <div className="flex flex-col items-center justify-center space-y-4 py-8 text-center">
      <div className="relative">
        <CheckCircle className="w-16 h-16 text-green-500 animate-scale-in" />
      </div>
      <h2 className="text-xl font-bold text-[#34375B]">{title}</h2>
      <p className="text-normal font-normal text-[#34375B]/70">
        {message}
      </p>
      <p className="text-sm font-thin text-[#34375B]/70">
        {submessage}
      </p>
    </div>
  );
};